export const pixelSpring = {
  type: 'spring',
  stiffness: 250,
  damping: 70,
  mass: 1,
};

export const riseIn = (delay = 0, y = 60, amount = 0.2) => ({
  initial: { y, opacity: 0 },
  whileInView: { y: 0, opacity: 1 },
  viewport: { once: true, amount },
  transition: { ...pixelSpring, delay },
});

export const fadeIn = (delay = 0, amount = 0.2) => ({
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport: { once: true, amount },
  transition: { ...pixelSpring, delay },
});
